import { useMemo } from 'react';
import { useFeatureFlag } from 'modules/common/hooks';
import { TimeSignal } from 'graphql/types';
import {
  NOTES_GROUP_BY_TYPE,
  useNotesFilterContext
} from 'modules/notes/NotesFilterContextProvider';
import { UNCATEGORIZED_GROUP_KEY } from '../useGroupBy';
import { GroupDurationCalculator } from './GroupDurationCalculator';
import { OverlapDeduplicationDurationStrategy } from './OverlapDeduplicationDurationStrategy';
import { SumDurationStrategy } from './SumDurationStrategy';

export const useGroupDurations = (
  groupedNotes: Record<string, TimeSignal[]>
): Record<string, number> => {
  const isTIWebGroupViewEnabled: boolean = useFeatureFlag(
    'isTIWebGroupViewEnabled',
    false
  );
  const {
    filterContext: { groupBy }
  } = useNotesFilterContext();

  return useMemo(() => {
    const map = new Map<string, number>();
    Object.keys(groupedNotes).forEach((key: string) => {
      const strategy =
        groupBy === NOTES_GROUP_BY_TYPE.LABELS &&
        !key.includes(UNCATEGORIZED_GROUP_KEY)
          ? new OverlapDeduplicationDurationStrategy()
          : new SumDurationStrategy(isTIWebGroupViewEnabled);
      const calculator = new GroupDurationCalculator(strategy);

      const notes = groupedNotes[key];
      const duration = calculator.calculate(notes);
      map.set(key, duration);
    });

    return Object.fromEntries(map);
  }, [groupBy, isTIWebGroupViewEnabled, groupedNotes]);
};
